import { Component, OnInit, ViewChild } from '@angular/core';
import { JhiAlertService, JhiEventManager } from 'ng-jhipster';
import { Subscription } from 'rxjs';

import { SoftwareInventoryService } from '../../services';
import { PackageType, UpdatePackage } from '../../models';
import { AlertUtils, FileUtils } from '../../shared';
import { UPDATE_PACKAGES_LIST_MODIFICATION } from '../../shared/constants';
import { FileInputComponent } from '../../components/generic';
import { scrollToTop } from '../../shared/utils/global-utils';

// TODO: move it under /inventory URL
@Component({
    selector: 'qms-updates',
    templateUrl: './updates.component.html'
})
export class UpdatesComponent implements OnInit {
    public packages: UpdatePackage[];
    public isSaving: boolean;
    public types: PackageType[] = ['KIOSK', 'DISPLAY', 'TERMINAL'];

    public selectedFile: File;
    public selectedType: PackageType;
    public version: string;
    public tag: string;

    public maxLengthVersion = UpdatePackage.MAX_VERSION_LENGTH;
    public maxLengthTag = UpdatePackage.MAX_TAG_LENGTH;
    public maxFileSize = UpdatePackage.MAX_FILE_SIZE_KB;

    @ViewChild(FileInputComponent)
    private fileInput: FileInputComponent;

    private eventSubscription: Subscription;

    constructor(private softwareInventoryService: SoftwareInventoryService,
                private eventManager: JhiEventManager,
                private alertService: JhiAlertService) {
    }

    ngOnInit() {
        this.loadUpdatePackages();
        this.registerChangeInUpdates();
    }

    public loadUpdatePackages() {
        this.softwareInventoryService.all().subscribe((response: UpdatePackage[]) => {
            this.packages = response;
        });
    }

    public upload() {
        this.isSaving = true;

        this.softwareInventoryService
            .upload(this.selectedFile, this.selectedType, this.version, this.tag)
            .subscribe((response: UpdatePackage) => {
                this.onSaveSuccess(response);

                // Clear current input
                this.version = null;
                this.tag = null;
                this.selectedType = null;
                this.fileInput.clearFile();
                this.selectedFile = null;

            }, () => {
                this.isSaving = false;
                scrollToTop();
            });
    }

    public setFileData(event: any) {
        const file = FileUtils.retrieveFileFromEvent(event);
        this.selectedFile = file;
        if (!file) {
            AlertUtils.notifyError(this.eventManager, this.alertService, 'update.loadFailed');
        }
    }

    public clearSelectedFile() {
        this.selectedFile = null;
    }

    private onSaveSuccess(result: UpdatePackage) {
        AlertUtils.notifySuccess(this.eventManager, this.alertService, 'update.created');
        this.isSaving = false;
        this.loadUpdatePackages();
    }

    private registerChangeInUpdates() {
        this.eventSubscription = this.eventManager.subscribe(UPDATE_PACKAGES_LIST_MODIFICATION, (response) => {
            this.loadUpdatePackages();
        });
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/admin/updates/updates.component.ts